<template>
	<div tag="div" class="flex items-center mr-base">
		<img v-if="companyLogo" :src="companyLogo" class="w-10 mr-1 fill-current text-primary" alt="" />
		<span
			class="vx-logo-text hidden lg:block"
			style="font-family: 'Poppins', sans-serif; font-size: 18px !important"
			:style="{color: $store.state.moduleSetting.navbarColor === '#fff' ? '#626262' : 'white'}"
			>{{ title }}</span
		>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";

export default {
	data() {
		return {
			visualConfig: null,
			companyText: "",
			companyLogo: "",
		};
	},
	computed: {
		title() {
			return this.companyText ? this.companyText : "";
		},
	},
	methods: {
		getCompanyLogo(url) {
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.companyLogo = res;
				})
				.catch((error) => {});
		},
	},
	created() {
		this.$store
			.dispatch("moduleCompanyConfig/fetchCompanyConfigList")
			.then((res) => {
				this.visualConfig = res.data.find((config) => config.type_config_name === "VISUAL_CONFIG");

				if (this.visualConfig && this.visualConfig.config_json) {
					const {url_logo} = this.visualConfig.config_json;
					this.companyLogo = url_logo ? url_logo : "";
					this.companyText = this.visualConfig.config_json.text;
				}
			})
			.catch((error) => {
				console.error(error);
			});
	},
};
</script>
